/**
 * 根据ua返回是否是微信:微信返回true
 */
const isWechat = function() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf("micromessenger") >= 0 || ua.indexOf("windows phone") >= 0) {
        return true;
    } else {
        return false;
    }
};
export const isIos = function() {
    var ua = window.navigator.userAgent;
    if (/iphone|ipad|ipod/i.test(ua)) {
        return true;
    } else {
        return false;
    }
};
export function getUgid() {
    return 'a12a1234-ab1a-1234-a123-1abc12a12abc';
}
export function getSessionId() {
    let sessionId = localStorage.getItem('sessionId');
    if (!sessionId) {
        sessionId = new Date().getTime();
        localStorage.setItem('sessionId', sessionId);
    }
    return sessionId;
}
export function getStoreUuid() {
    var uuid = localStorage.getItem("ZUID");
    if (!uuid) {
        uuid = createUuid();
        localStorage.setItem("ZUID", uuid);
    }
    return uuid;

    /*
     * 辅助生成zuid的方法
     * */
    function createUuid() {
        var str = "";
        if (isWechat() && isIos()) { //ios 微信
            str = "3";
        } else if (isWechat() && !isIos()) { //android 微信
            str = "4";
        } else if (isIos()) { //ios 客户端
            str = "1";
        } else { //android 客户端
            str = "2";
        }
        return 'xxxxxxxxxxxxxxxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        }) + "|12345678900" + str;
    }
};

export function IsPC() {
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone",
        "iPad", "iPod"];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}

export function IsInviteMode() {
  const url = window.location.href;
  if (url && url.includes("invite")) {
    return true;
  }
  return false;
}

// time 为时间戳
export function DateFormat(time = new Date()) {
  const dateObj = new Date(time);
  const year = dateObj.getFullYear();
  const month = dateObj.getMonth() + 1;
  const day = dateObj.getDate();
  return `${day}/${month}/${year}`
}

/**
 * @param obj
 * 判断数据是否为空
 */
export function isNullOrEmpty (obj) {
  var result = (obj == null || obj == undefined || obj == "" || obj == "null" || obj == "undefined" || typeof obj == "undefined");
  if (result && (obj != 0 || obj != "0")) {
    return result;
  } else {
    return false;
  }
}

export function getParam(name, searchUrlOnly = true) {
  if (!name) return null;

  let values = sessionStorage.getItem(name);
  if (!searchUrlOnly && values) return values;

  values = decodeURIComponent((location.search.match(RegExp("[?|&|/]" + name + '=([^/\&|?&]+)')) || [, null])[1]);
  if (isNullOrEmpty(values)) {
    values = decodeURIComponent((location.hash.match(RegExp("[?|&|/]" + name + '=([^\&|?&]+)')) || [, null])[1]);
  }
  return isNullOrEmpty(values) || values === "null" ? "" : values;
}
